import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService, AuthService, SessionService } from '@nstep-common/core';
import { AppPermissions } from '@nstep-public/app/shared';
import { ExtendedPOSLocationDto, LocationType } from '@nstep-public/pages';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class OperatorService {

	constructor(private apiService: ApiService,
		private authService: AuthService,
		private sessionService: SessionService,
		private router: Router) {
	}

	getLocations(): Observable<ExtendedPOSLocationDto[]> {
		return this.apiService.get([ExtendedPOSLocationDto], 'pos-operator/locations');
	}

	setLocationInfo(posLocationInfo: ExtendedPOSLocationDto): void {
		let canAddBalance = false;
		let canPurchaseTransactions = false;

		// I know...
		if (this.authService.jwt) {
			canAddBalance = posLocationInfo.location.locationTypes.some(type => type == LocationType.AddBalance) &&
				this.authService.jwt.subRoles.some(subRole => Number(subRole) == LocationType.AddBalance);

			canPurchaseTransactions = posLocationInfo.location.locationTypes.some(type => type == LocationType.PurchaseTransactions) &&
				this.authService.jwt.subRoles.some(subRole => Number(subRole) == LocationType.PurchaseTransactions);
		}

		this.sessionService.set(AppPermissions.addBalance, canAddBalance.toString());
		this.sessionService.set(AppPermissions.onlineTransactions, canPurchaseTransactions.toString());

		this.sessionService.set('locationInfo', JSON.stringify(posLocationInfo));
	}

	getLocationInfo(): ExtendedPOSLocationDto | null {
		const json = this.sessionService.get('locationInfo');

		if (!json) {
			this.router.navigate(['select-location']);
			return null;
		}

		return JSON.parse(json) as ExtendedPOSLocationDto;
	}

	haslocationInfo(): boolean {
		return 'locationInfo' in localStorage;
	}
}
